<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 0, 18, 0]">
        <v-tooltip />
        <v-smooth-area  :position="'x*'+yTitle" />
      </v-chart>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  const tooltip = [
    'x*y',
    (x, y) => ({
      name: x,
      title: '时间',
      value: y
    })
  ]
  const scale = [{
    dataKey: 'x',
  }, {
    dataKey: 'y',
    title: '时间',
  }]

  export default {
    name: 'MiniArea',
    props: {
      data:{
        type: Array,
        default:[]
      },
      yTitle:{
        type: String,
        default:''
      },
    },
    data () {
      return {
        tooltip,
        scale,
        height: 100
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "chart";
</style>